<template>
    <div class="form-group" :class="theClasses">
        <label v-if="!!label" for="">{{ label }} <span v-if="!!required" class="field-required-mark">*</span></label>
        <!-- <select class="form-control" @change="updateValue($event.target.value)" :value="typeof value === 'object'?value[fieldKey]:value" :disabled="disabled"> -->
        <select class="form-control" v-model="selectedValue" :disabled="disabled">
            <option value="" >{{ placeholder }}</option>
            <option
                v-for="(option, i) in options"
                :value="option[fieldKey]"
                :key="i"
            >{{ option[fieldValue] }}</option>
        </select>
        <span v-if="hasError" class="field-error">{{ errorMessage }}</span>
    </div>
</template>
<script>
    export default {
        props: {
            label: {
                type: String,
                default: ''
            },
            hasError: {
                type: Boolean,
                default: false
            },
            errorMessage: {
                type: String,
                default: ''
            },
            options: {
                type: Array,
                default: () => []
            },
            fieldKey: {
                type: String,
                default: 'id'
            },
            fieldValue: {
                type: String,
                default: 'name'
            },
            placeholder: {
                type: String,
                default: '-- Seleccione --'
            },
            required: {
                default: false
            },
            value: {
                default: ''
            },
            disabled: {
                default: false
            },
            isObject: {
                type: Boolean,
                default: false
            },
            classes: {
                default: ''
            }
        },
        data(){
            return {
                selectedValue: ''
            }
        },
        watch: {
            selectedValue(val){
                if(typeof val === 'undefined') return;
                this.updateValue(val);
            },
            options(val){
                if(!this.value) return;

                this.selectedValue = !!this.isObject? this.value[this.fieldKey]:this.value;
            },
            value(val){
                this.selectedValue = !!this.isObject?val[this.fieldKey]:val;
            }
        },
        methods: {
            updateValue(val){
                const result = this.isObject? this.options.find(item => item[this.fieldKey] === val): val;
                this.$emit('input', result);
                this.$emit('change', result);
            }
        },
        computed: {
            theClasses(){
                if(typeof this.classes === 'string'){
                    const classes = {};
                    classes[this.classes] = 1;
                    return classes;
                }

                if(Array.isArray(this.classes)){
                    const classes = {};
                    this.classes.map(theClass => classes[theClass] = 1);
                    return classes;
                }

                if(this.classes && typeof this.classes === 'object' && this.classes.constructor === Object){
                    return this.classes;
                }
            }
        }
    }
</script>